
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Guide de A à Z – Tout savoir sur Instagram",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Depuis son lancement en 2010, Instagram s’est imposé comme une plateforme incontournable dans le monde du numérique.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Guide de A à Z – Tout savoir sur Instagram",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Depuis son lancement en 2010, Instagram s’est imposé comme une plateforme incontournable dans le monde du numérique.",
        },
      ],
    };
  },
};
